import React from 'react';
import ProTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import storage from './storage';

import { requestProjectDetail, loadProject } from '../lib/http';

import { fetchWorkSource } from '../reducers/project-state-modify';

import { isJustLogined } from '../reducers/user-info';

import { getParameterByName } from '../lib/tool';

import {
    onFetchedProjectData,
    projectError
} from '../reducers/project-state';

import { setProjectTitle } from '../reducers/project-title';

import { base64ToArrayBuffer } from './tool';

const createUrl = getParameterByName('createUrl');

const ProjectFetcherHOCModify = WrappedComponent => {
    class ProjectFetcherModify extends React.Component {
        constructor(props) {
            super(props);
            bindAll(this, [
                'fetchProject'
            ]);
        }

        fetchProjectById(id) {
            return requestProjectDetail({ customerProjectId: id })
        }

        fetchProject(projectId, loadingState) {
            const validProjectId = /\d{2,}/g;

            if (createUrl || validProjectId.test(projectId)) {
                let fetchScratchSource;
                if (createUrl) {
                    fetchScratchSource = loadProject(createUrl);
                } else {
                    fetchScratchSource = this.props.fetchWorkSource(projectId);
                }

                fetchScratchSource
                    .then(res => {
                        const reader = new FileReader();
                        reader.readAsArrayBuffer(res.data);
                        reader.onload = () => {
                            this.props.onFetchedProjectData(reader.result, loadingState)
                        }
                        reader.onerror = () => {
                            throw new Error('project-state-modify: loadProject 获取资源转换错误！')
                        }
                    }).catch(err => {
                        this.props.onError(err);
                        log.error(err);
                    })
            } else {
                const { justLogined, isJustLogined } = this.props;
                if (justLogined == 'true') {
                    const projectName = localStorage.getItem('projectName');
                    const projectFile = localStorage.getItem('projectFile');

                    const { setProjectTitle, onFetchedProjectData } = this.props;

                    isJustLogined(false);
                    setProjectTitle(projectName);
                    return onFetchedProjectData(base64ToArrayBuffer(projectFile), loadingState);
                }
                return storage.load(storage.AssetType.Project, projectId, storage.DataFormat.JSON).then(projectAsset => {
                    if (projectAsset) {
                        this.props.onFetchedProjectData(projectAsset.data, loadingState);
                    } else {
                        // Treat failure to load as an error
                        // Throw to be caught by catch later on
                        throw new Error('Could not find project');
                    }
                }).catch(err => {
                    this.props.onError(err);
                    log.error(err);
                });
            }
        }

        render() {
            const {
                justLogined,
                isJustLogined,
                fetchWorkSource,
                setProjectTitle,
                onError: onErrorProp,
                onFetchedProjectData: onFetchedProjectDataProp,
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    fetchProject={this.fetchProject}
                    {...componentProps}
                />
            )
        }

    }

    // ProjectFetcherModify.propTypes = {
    //     vm: ProTypes.instanceOf(VM).isRequired
    // }

    const mapStateToProps = (state) => ({ user: state.session.session, justLogined: state.session.justLogined });

    const mapDispatchToProps = dispatch => ({
        fetchWorkSource: id => dispatch(fetchWorkSource(id)),
        onFetchedProjectData: (projectData, loadingState) =>
            dispatch(onFetchedProjectData(projectData, loadingState)),
        onError: error => dispatch(projectError(error)),
        setProjectTitle: projectName => dispatch(setProjectTitle(projectName)),
        isJustLogined: boolean => dispatch(isJustLogined(boolean))
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(ProjectFetcherModify)
}

export default ProjectFetcherHOCModify;



